import React from 'react';
import type { Todo } from '@signa/shared';

interface TodoInlineCardProps {
  todo: Todo;
  onOpen: () => void;
}

function formatDue(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return '';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = Math.round(
    (d.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
  );
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Tomorrow';
  if (diff === -1) return 'Yesterday';
  if (diff > 0 && diff < 7) return d.toLocaleDateString([], { weekday: 'long' });
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

export function TodoInlineCard({ todo, onOpen }: TodoInlineCardProps) {
  const done = !!todo.completedAt;
  const due = formatDue(todo.dueDate);
  return (
    <button
      type="button"
      onClick={onOpen}
      style={{
        display: 'flex',
        width: '100%',
        textAlign: 'left',
        padding: '12px 14px',
        background: 'var(--card)',
        border: '1px solid var(--rule)',
        borderRadius: 10,
        cursor: 'pointer',
        marginBottom: 8,
        gap: 12,
        alignItems: 'flex-start',
        fontFamily: 'var(--font-ui)',
        transition: 'border-color 150ms ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--accent)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--rule)';
      }}
    >
      <span
        aria-hidden
        style={{
          width: 16,
          height: 16,
          borderRadius: 4,
          border: `1.5px solid ${done ? 'var(--accent)' : 'var(--ink-faint)'}`,
          background: done ? 'var(--accent)' : 'transparent',
          flexShrink: 0,
          marginTop: 2,
        }}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 14,
            color: done ? 'var(--ink-faint)' : 'var(--ink)',
            textDecoration: done ? 'line-through' : 'none',
          }}
        >
          {todo.title}
        </div>
        {due && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              marginTop: 6,
              fontFamily: 'var(--font-mono)',
              fontSize: 10.5,
              color: due === 'Today' ? 'var(--accent)' : 'var(--ink-faint)',
              letterSpacing: '0.3px',
            }}
          >
            {due}
          </div>
        )}
      </div>
    </button>
  );
}
